<template>
  <NuxtLayout name="default" class="theme-prob">
    <PageBlocks
      v-if="page"
      :content="page.blocks"
      :error="error"
      class="app-width-large"
    >
      <template #header>
        <BlocksHeadersHeaderHero
          :title="project.name"
          :hero="project.cover"
          :detail="{
            client: project.client ? project.client.name : null,
            date: project.endDate ? `${project.startDate} - ${project.endDate}` : project.startDate,
          }"
        />
      </template>

      <template #footer>
        <template v-if="project?.partners?.length">
          <UiTitleArrow :level="3" :content="'Partenaires'" class="app-gutter" />
          <Partners :collection="project.partners" class="app-width-large" />
        </template>

        <Share
          :title="project.name"
          :description="project.name"
          class="app-gutter-mobile-only app-width-small"
        />

        <template v-if="project?.tags?.length">
          <div class="taglist app-gutter-mobile-only app-width-small">
            <UiTag
              v-for="tag in project.tags"
              :key="tag.id"
              :label="tag.label"
              :href="`${tagRootPath}?filter=${tag.slug}`"
            />
          </div>
        </template>

        <template v-if="project?.related.length">
          <UiTitleArrow :level="3" :content="'Poursuivre la lecture'" class="app-gutter" />
          <Related :items="project.related" />
        </template>
      </template>
    </PageBlocks>
  </NuxtLayout>
</template>

<script setup>
import { getProjectFromData } from '~/data/project';
definePageMeta({ layout: false });

const route = useRoute();
const { error, page, data } = await useFetchByPath(route.path);
const tagRootPath = route?.matched?.[0]?.path;

/* here page specifics */
const project = getProjectFromData(data.data);
</script>

<style lang="stylus" scoped>
.taglist {
  display flex
  gap 15px
  justify-content center
  margin-top 50px
  margin-bottom 100px
}
</style>
